export default __webpack_public_path__ + "static/media/raspberry.37e496fe.jpg";